<script lang="ts">
	import type { DatasheetPoiData } from '../../types';
	import { page } from '$app/stores';
	import Button from '$lib/components/atoms/button/Button.svelte';
	import { isAnyPoiPartner } from '$lib/constants/sponsoredPoi';
	import { getSearchParamsStore } from '$lib/services/urls/searchParams';
	import * as m from '$paraglide/messages';
	import { createEventDispatcher } from 'svelte';
	import { getBookUrl } from '../../utils';
	import DatasheetLocation from '../DatasheetLocation.svelte';
	import DatasheetToolbar from '../toolbar/DatasheetToolbar.svelte';
	import DatasheetDetailLocation from './DatasheetDetailLocation.svelte';
	import DatasheetDetailPracticalInfos from './DatasheetDetailPracticalInfos.svelte';
	import DatasheetDetailStrongPoints from './DatasheetDetailStrongPoints.svelte';
	import DatasheetDetailText from './DatasheetDetailText.svelte';
	import DatasheetEvConnectors from './ev-connectors/DatasheetEVConnectors.svelte';

	export let poi: DatasheetPoiData;

	const dispatch = createEventDispatcher<{
		seeOnMap: void;
		itineraryClick: void;
	}>();

	const searchParams = getSearchParamsStore();
</script>

{#if poi.__typename === 'AccommodationPOI'}
	{#if poi.description}
		<DatasheetDetailText title={m.poi_datasheet__description()} text={poi.description} />
	{/if}
	{#if poi.facilities}
		<DatasheetDetailStrongPoints strongPoints={poi.facilities} color="hotelAlt" />
	{/if}
{:else if poi.__typename === 'AccommodationMichelinPOI'}
	{#if poi.description}
		<DatasheetDetailText title={m.poi_datasheet__description()} text={poi.description} />
	{/if}
	{#if poi.facilities}
		<DatasheetDetailStrongPoints strongPoints={poi.facilities} color="hotelAlt" />
	{/if}
{:else if poi.__typename === 'RestaurantMichelinPOI'}
	{#if poi.description}
		<DatasheetDetailText title={m.poi_datasheet__michelin_opinion()} text={poi.description} />
	{/if}
	{#if poi.facilities}
		<DatasheetDetailStrongPoints strongPoints={poi.facilities} color="restaurantAlt" />
	{/if}
{:else if poi.__typename === 'TourismPOI'}
	{#if poi.description}
		<DatasheetDetailText
			title={m.poi_datasheet__michelin_opinion__tourism()}
			text={poi.description}
		/>
	{/if}
	{#if poi.phone || poi.redirectUrl}
		<DatasheetDetailPracticalInfos
			phone={poi.phone ?? undefined}
			website={poi.redirectUrl ?? undefined}
		/>
	{/if}
{:else if poi.__typename === 'ServiceEVPOI'}
	{#if poi.connectors}
		<DatasheetEvConnectors connectors={poi.connectors} />
	{/if}
{:else if poi.__typename === 'ServiceRestStopPOI'}
	{#if poi.fullAddress}
		<div class="flex justify-center">
			<DatasheetLocation
				address={poi.fullAddress}
				onAddItineraryClick={() => {
					dispatch('itineraryClick');
				}}
				seeOnMap={() => {
					dispatch('seeOnMap');
				}}
			/>
		</div>
	{/if}
{:else if isAnyPoiPartner(poi)}
	<DatasheetToolbar
		showItineraryButton
		showLearnMoreButton
		hasShadow={false}
		bookUrl={getBookUrl(poi, $page, $searchParams)}
		learnMoreLabel={poi.callToAction}
		on:itineraryClick
		on:learnMoreClick
	/>

	{#if poi.description}
		<DatasheetDetailText title={poi.datasheetTitle} text={poi.description} />
	{/if}
	{#if poi.practicalInformations || poi.practicalInformations2 || poi.practicalInformations3}
		<DatasheetDetailPracticalInfos
			infos={[poi.practicalInformations, poi.practicalInformations2, poi.practicalInformations3]}
		/>
	{/if}
{/if}
{#if poi.address.formattedAddress || poi.address.formattedCity}
	<DatasheetDetailLocation
		streetName={poi.address.formattedAddress || undefined}
		city={poi.address.formattedCity || undefined}
	/>
{/if}

{#if poi.__typename !== 'ServiceRestStopPOI'}
	<Button
		color="primary"
		icon="map"
		onclick={() => {
			dispatch('seeOnMap');
		}}
		text={m.poi_datasheet__see_on_map()}
		variant="outline"
	/>
{/if}
